import { render, staticRenderFns } from "./LicenseUpload.vue?vue&type=template&id=629581aa&scoped=true&"
import script from "./LicenseUpload.vue?vue&type=script&lang=ts&"
export * from "./LicenseUpload.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseUpload.vue?vue&type=style&index=0&id=629581aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629581aa",
  null
  
)

export default component.exports